<template>
  <a-modal width="45%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>配置商品发货时间</b>
    </a-divider>
    <a-button  type="primary" style="width: 20%" @click="addGoodsCount()" class="margin-bottom">
      <a-icon type="plus"/>
      添加
    </a-button>
    <a-table :data-source="goodsCountDeliveryTimeList" :columns="skuColumns" :pagination="false" bordered>
      <div slot="deliveryTime" slot-scope="text, record">
        <a-input-number v-model="record.deliveryTime"
                        :min="1" :max="100" :step="1"
                        :placeholder="$t('请输入')+'发货天数'"  />
        <span>天内发</span>
      </div>
      <span slot="minGoodsCount" slot-scope="text, record">
         <a-input-number v-model="record.minGoodsCount"
                         style="width: 45%"
                         :min="0" :max="10000000000" :step="1"
                         placeholder="起始数量"  />
                <span>-</span>
        <a-input-number v-model="record.maxGoodsCount"
                        style="width: 45%"
                        :min="0" :max="10000000000" :step="1"
                        placeholder="结束数量"  />
      </span>
      <div slot="action" slot-scope="text, record" >
        <a href="javascript:void(0)" @click="dekGoodsCount(record)" style="color:red;" >删除</a>
      </div>
    </a-table>
  </a-modal>
</template>

<script>
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      goodsCountDeliveryTimeList:[
      ],
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage:undefined,
      skuColumns: [
        {
          title: '购买数量',
          dataIndex: 'minGoodsCount',
          scopedSlots: {customRender: 'minGoodsCount'},
          width: '50%',
          key: 'minGoodsCount',
        },
        {
          title: '发货天数',
          dataIndex: 'deliveryTime',
          key: 'deliveryTime',
          scopedSlots: {customRender: 'deliveryTime'}
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          slots: {title: 'addbtn', customRender: 'name'},
          scopedSlots: {customRender: 'action'}
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.goodsCountDeliveryTimeList = [
      ]
    },
    /** 修改按钮操作 */
    show(goodsCountDeliveryTimeList) {
      if (goodsCountDeliveryTimeList && goodsCountDeliveryTimeList.length > 0) {
        this.goodsCountDeliveryTimeList = goodsCountDeliveryTimeList;
      }
      this.open = true
    },
    addGoodsCount() {
      const newData = {
        minGoodsCount: null,
        maxGoodsCount: null,
        deliveryTime: 1
      };
      if (this.goodsCountDeliveryTimeList.length === 0) {
        const firstData = {
          minGoodsCount: 1,
          maxGoodsCount: null,
          deliveryTime: 1
        };
        this.goodsCountDeliveryTimeList.push(firstData);
      } else {
        this.goodsCountDeliveryTimeList.push(newData);
      }
    },
    dekGoodsCount(record) {
      this.goodsCountDeliveryTimeList = this.goodsCountDeliveryTimeList.filter(e => e.minGoodsCount !== record.minGoodsCount);
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('goodsCountDeliveryTime', this.goodsCountDeliveryTimeList)
      this.reset()
    },
  }
}
</script>
